import { IReminder, Therapy } from '@alberta/konexi-shared';

export class ReminderDto implements IReminder {
  hasBeenSeen: boolean;
  entityType: 'singleOrder' | 'integratedCare';
  entityId: string;
  parentId: string;
  therapy: Therapy;
  patientId: string;
  regionId: string;
  date: Date;
  annotation: string;
  userId: string;
  _id: string;
  timestamp: Date;
  archived: boolean;
}
